import React, {PureComponent} from 'react';
import {Modal} from 'react-responsive-modal';
import ReactTooltip from "react-tooltip";
import $ from "jquery";
import {formatDate} from "../functions/utils";
import {withTranslation} from "react-i18next";

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const device_on_interval = 33000;
const auto_refresh = 90000;

let refreshInterval = null;

class DiagnosticModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            diagnosis: {
                sat: false,
                fix: false,
                bat: false,
                ena: false,
                eim: false,
                eos: false,
                elu: false,
                elg: false,
                eip: false,
                sas: false,
                sim: false,
                sop: false,
                soc: false,
                sic: false,
                ssg: false,
                svl: false,
                smc: false,
                pcd: false,
                pdu: false,
                pim: false,
                pip: false,
                prt: false,
                doc: false,
                per1: {},
                per2: {},
                per3: {},
                per4: {},
            },
            row: <tr/>,
        };

        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.fetchInfo = this.fetchInfo.bind(this);
        this.makeRow = this.makeRow.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.carObj !== this.props.carObj) {
            clearInterval(refreshInterval);
            this.fetchInfo();
            refreshInterval = setInterval(() => {
                this.fetchInfo();
            }, auto_refresh);
        }
    }

    fetchInfo() {
        const helper = this;
        $.ajax({
            type: 'GET',
            url: telemetryIP + ':' + messagePort + '/device-minimal-diagnosis-refresh?eventId=' + helper.props.eventID + "&sessionId=" + helper.props.sessionID + "&carId=" + helper.props.carObj.id,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function (data) {
                console.log('[DIAGNOSTIC MODAL] Successfully sent device list refresh request.');
                helper.setState({
                    carData: data.dat[0],
                }, () => {
                    helper.makeRow();
                });
            }, error: function (err) {
                if (err) {
                    console.error('[DIAGNOSTIC MODAL] Error sending device list refresh request.', err);
                    $('.loading').fadeOut();
                    helper.setState({
                        row: <tr/>,
                    });
                }
            }
        });
    }

    makeRow() {
        // Process device ON LED light color
        let device_on_led_color = "";
        let device_on_tooltip = "";
        if (parseInt(this.state.carData.dif) < device_on_interval) {
            device_on_led_color = "green";
            device_on_tooltip = this.props.t("deviceON");
        } else {
            device_on_led_color = "red";
            device_on_tooltip = this.props.t("deviceOFF");
        }

        // Process OBD status LED light color
        let obd_led_color;
        let obd_tooltip;
        switch (this.state.carData.ost) {
            case (0): {
                obd_led_color = "red";
                obd_tooltip = "OBD " + this.props.t("notWorking");
                break;
            }
            case (1): {
                obd_led_color = "yellow";
                obd_tooltip = "OBD " + this.props.t("searchingProtocol");
                break;
            }
            case (2): {
                obd_led_color = "green";
                obd_tooltip = "OBD " + this.props.t("connected");
                break;
            }
            default: {
                obd_led_color = "red";
                obd_tooltip = "OBD " + this.props.t("unknownState");
                break;
            }
        }
        // Override to RED color if device turned OFF
        if (device_on_led_color === "red") {
            obd_led_color = "red";
            obd_tooltip = this.props.t("deviceOFF");
        }

        // Process GPS status LED light color
        let gps_led_color = "";
        let gps_tooltip = "";
        switch (this.state.carData.gst) {
            case (0): {
                gps_led_color = "white";
                gps_tooltip = "GPS " + this.props.t("notWorking");
                break;
            }
            case (1): {
                gps_led_color = "red";
                gps_tooltip = "GPS " + this.props.t("waitingFix");
                break;
            }
            case (3): {
                gps_led_color = "blue";
                gps_tooltip = "GPS " + this.props.t("initializing");
                break;
            }
            case (2): {
                if (this.state.carData.sat <= 5) {
                    gps_led_color = "yellow";
                    gps_tooltip = this.props.t("weakSignal") + " (" + this.state.carData.sat + " sat.)";
                } else if (this.state.carData.sat >= 6 && this.state.carData.sat <= 9) {
                    gps_led_color = "blue";
                    gps_tooltip = this.props.t("mildSignal") + " (" + this.state.carData.sat + " sat.)";
                } else if (this.state.carData.sat >= 10) {
                    gps_led_color = "green";
                    gps_tooltip = this.props.t("strongSignal") + " (" + this.state.carData.sat + " sat.)";
                } else {
                    gps_led_color = "red";
                    gps_tooltip = "GPS " + this.props.t("unknownState");
                }
                break;
            }
            case (4): {
                gps_led_color = "red";
                gps_tooltip = this.props.t("gpsError");
                break;
            }
            default: {
                gps_led_color = "red";
                gps_tooltip = "GPS " + this.props.t("unknownState");
                break;
            }
        }
        // Override to RED color if device turned OFF
        if (device_on_led_color === "red") {
            gps_led_color = "red";
            gps_tooltip = this.props.t("deviceOFF");
        }

        // Process GSM status LED light color
        let gsm_led_color = "";
        let gsm_tooltip = "";
        let gsm_icon = "gsm_0";
        if (this.state.carData.gsm <= 1) {
            gsm_tooltip = this.props.t("deadSignal");
            gsm_led_color = "red";
            gsm_icon = "gsm_1";
        } else if (this.state.carData.gsm >= 2 && this.state.carData.gsm <= 9) {
            gsm_tooltip = this.props.t("marginalSignal");
            gsm_led_color = "yellow";
            gsm_icon = "gsm_2";
        } else if (this.state.carData.gsm >= 10 && this.state.carData.gsm <= 14) {
            gsm_tooltip = this.props.t("stableSignal");
            gsm_led_color = "blue";
            gsm_icon = "gsm_3";
        } else if (this.state.carData.gsm >= 15 && this.state.carData.gsm <= 19) {
            gsm_tooltip = this.props.t("goodSignal");
            gsm_led_color = "green";
            gsm_icon = "gsm_4";
        } else if (this.state.carData.gsm >= 20 && this.state.carData.gsm <= 31) {
            gsm_tooltip = this.props.t("excelentSignal");
            gsm_led_color = "green";
            gsm_icon = "gsm_5";
        } else if (this.state.carData.gsm > 31) {
            gsm_tooltip = this.props.t("unknownState");
            gsm_led_color = "yellow";
            gsm_icon = "gsm_0";
        } else {
            gsm_tooltip = this.props.t("unknownState");
            gsm_led_color = "yellow";
            gsm_icon = "gsm_0";
        }
        // Override to RED color if device turned OFF
        if (device_on_led_color === "red") {
            gsm_led_color = "red";
            gsm_tooltip = this.props.t("deviceOFF");
            gsm_icon = "gsm_0";
        }

        let tmc_led_color = "";
        let tmc_tooltip = "";
        if (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) {
            // Process Team Manager Connected status LED light color
            switch (this.state.carData.tmc) {
                case (0): {
                    tmc_led_color = "red";
                    tmc_tooltip = this.props.t("offline").toUpperCase();
                    break;
                }
                case (1): {
                    tmc_led_color = "green";
                    tmc_tooltip = this.props.t("online").toUpperCase();
                    break;
                }
                default: {
                    tmc_led_color = "yellow";
                    tmc_tooltip = this.props.t("unknownState").toUpperCase();
                    break;
                }
            }
        }

        // Process Connected Peripherals status LED light color
        let per_led_color;
        let per_tooltip;
        switch (this.state.carData.per) {
            case (0): {
                per_led_color = "red";
                per_tooltip = this.props.t("noPeripherals");
                break;
            }
            case (1): {
                per_led_color = "green";
                per_tooltip = this.props.t("hasPeripherals");
                break;
            }
            default: {
                per_led_color = "yellow";
                per_tooltip = this.props.t("unknown");
                break;
            }
        }

        // Process Update status LED light color
        let fw_update_led_color;
        let fw_update_tooltip;

        if (this.state.carData.fwu) {
            switch (this.state.carData.fwu.sts) {
                case(0): {
                    fw_update_led_color = "yellow";
                    fw_update_tooltip = this.props.t("updateAvailable");
                    break;
                }
                case(1): {
                    fw_update_led_color = "blue";
                    fw_update_tooltip = this.props.t("updating") + " (" + this.state.carData.fwu.prg + "%)";
                    break;
                }
                case(2): {
                    fw_update_led_color = "green";
                    fw_update_tooltip = this.props.t("upToDate");
                    break;
                }
                default: {
                    fw_update_led_color = "red";
                    fw_update_tooltip = this.props.t("unknown");
                    break;
                }
            }
        } else {
            switch (this.props.carObj.updated) {
                case (0): {
                    fw_update_led_color = "red";
                    fw_update_tooltip = this.props.t("updateNeeded");
                    break;
                }
                case (1): {
                    fw_update_led_color = "green";
                    fw_update_tooltip = this.props.t("upToDate");
                    break;
                }
                default: {
                    fw_update_led_color = "red";
                    fw_update_tooltip = this.props.t("unknown");
                    break;
                }
            }
        }

        // Bring information backwards on the REACT tree all the way back to the parent component
        setTimeout(() => {
            this.props.deviceStatusGetter(device_on_led_color, device_on_tooltip, gps_led_color, gps_tooltip, gsm_tooltip, gsm_led_color, gsm_icon);
        }, 500);

        // Dates
        let lastComm = formatDate(this.props.lastComm, Intl.DateTimeFormat().resolvedOptions().timeZone);
        let start = formatDate(this.props.carObj.last_comms_start_timestamp, Intl.DateTimeFormat().resolvedOptions().timeZone);
        let end = formatDate(this.props.carObj.last_comms_end_timestamp, Intl.DateTimeFormat().resolvedOptions().timeZone);

        let body = (
            <>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("speedSource")}</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        {this.props.carObj.speedSource}
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>OBD</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        <div className={"led-" + obd_led_color + "-static col-xs-offset-3 col-md-offset-0"} style={{margin: 0, marginBottom: 5}} data-tip={true} data-for={"obd_" + this.props.carObj.livery_number}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("firmware")}</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        {this.props.carObj.current_firmware_version_id ? this.props.carObj.current_firmware_version_id : "---"}
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("updateState")}</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        <div className={"led-" + fw_update_led_color + "-static col-xs-offset-3 col-md-offset-0"} style={{margin: 0, marginBottom: 5}} data-tip={true} data-for={"fw_update_" + this.props.carObj.livery_number}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("lastConnection")}</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        {this.props.lastComm ? (
                            lastComm !== null ? lastComm : "---"
                        ) : (
                            this.props.carObj.last_comms_end_timestamp > this.props.carObj.last_comms_start_timestamp ? (
                                end !== null ? end : "---"
                            ) : (
                                start !== null ? start : "---"
                            )
                        )}
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("peripherals")}</div>
                    <div className={"col-xs-4 text-left App_black_text"}>
                        <div className={"led-" + per_led_color + "-static col-xs-offset-3 col-md-offset-0"} style={{margin: 0, marginBottom: 5}} data-tip={true} data-for={"per_" + this.props.carObj.livery_number}/>
                    </div>
                </div>
                {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                    <div className={"row"}>
                        <div className={"col-xs-offset-2 col-xs-4 App_smallHeader"} style={{textAlign: "right"}}>{this.props.t("teamManager")}</div>
                        <div className={"col-xs-4 text-left App_black_text"}>
                            <div className={"led-" + tmc_led_color + "-static col-xs-offset-3 col-md-offset-0"} style={{margin: 0, marginBottom: 5}} data-tip={true} data-for={"tmc_" + this.props.carObj.livery_number}/>
                        </div>
                    </div>
                ) : null}
            </>
        );

        let tooltips = (
            <div key={this.props.carObj.livery_number}>
                <ReactTooltip id={"obd_" + this.props.carObj.livery_number} type={"light"}>
                    <span className={"App_title"}>{obd_tooltip}</span>
                </ReactTooltip>
                <ReactTooltip id={"fw_update_" + this.props.carObj.livery_number} type={"light"}>
                    <span className={"App_title"}>{fw_update_tooltip}</span>
                </ReactTooltip>
                <ReactTooltip id={"per_" + this.props.carObj.livery_number} type={"light"}>
                    <span className={"App_title"}>{per_tooltip}</span>
                </ReactTooltip>
                <ReactTooltip id={"tmc_" + this.props.carObj.livery_number} type={"light"}>
                    <span className={"App_title"}>{tmc_tooltip}</span>
                </ReactTooltip>
            </div>
        );

        this.setState({
            body: body,
            tooltips: tooltips,
        });
    }

    handleShowModal() {
        this.fetchInfo();
        this.setState({
            show: true
        });
    }

    handleClose() {
        this.setState({
            show: false,
        });
    }

    render() {

        let isDisabled;
        if ((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) && this.props.carID) {
            isDisabled = false;
        } else {
            isDisabled = this.props.isOwnTeam !== 1;
        }

        return (
            <>
                <button
                    className={"btn btn-primary btn-block button"}
                    data-tip={true}
                    data-for={"diagnosis"}
                    onClick={this.handleShowModal}
                    disabled={isDisabled}
                >
                    <i className="fas fa-toolbox App_buttonContainer_icons"/>
                </button>
                <ReactTooltip id={"diagnosis"} type={"light"}>
                    <span className={"toolTipStyle"}>{this.props.t("deviceDiag")}</span>
                </ReactTooltip>
                <Modal open={this.state.show}
                       onClose={this.handleClose}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <span className={"App_black_text"} style={{fontSize: 25}}>{this.props.t("deviceDiag")}</span>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        {this.state.body}
                        {this.state.tooltips}
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.fetchInfo}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        ><b>{this.props.t("forceRefresh")}</b>
                        </button>
                        <button
                            onClick={this.handleClose}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("close")}
                        </button>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withTranslation("translations")(DiagnosticModal);
